import React from "react";

const CompleteStep = () => {

    return (

        <div className="upload-step-placeholder">

            <h3>Complete Step</h3>

            <p>
                Temporary component for framework integration testing.
            </p>

        </div>

    );

};

export default CompleteStep;